import * as React from "react";

const AddedToCartCheckCircle: React.FC = () => (
    <svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
        <circle cx="14" cy="14" r="14" fill="#019D05" />
        <path
            d="M8 14.35L12.05 18.4L20.75 9.7"
            fill="none"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.6"
        />
    </svg>
);

export default React.memo(AddedToCartCheckCircle);
